const AuthFailed = () => (
  <div className="loading-page-container">
    <wb-text>
      Authentication failed. Please try to login VOISBot system again.
    </wb-text>
  </div>
);

export default AuthFailed;
